// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { FC } from "react";

export interface RfqConfirmationButtonsStyles {}

export const rfqConfirmationButtonsStyles: RfqConfirmationButtonsStyles = {};

const styles = rfqConfirmationButtonsStyles;

const RfqConfirmationButtons: FC = () => {
    return (
        <StyledWrapper>
            {createWidgetElement("RfqConfirmation/RfqConfirmationHeader", {
                showButtons: true,
                showTitle: false,
            } as any)}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: RfqConfirmationButtons,
    definition: {
        displayName: "RfqConfirmation buttons",
        allowedContexts: ["RfqConfirmationPage"],
        fieldDefinitions: [],
        group: "RFQ Quote Confirmation",
    },
};

export default widgetModule;
